const Theme = {
  button_radius: 25,
  button_no_border: true,
  token_url: 'theplaza.png',
  token_margin_right: 8,
  token_border_radius: 50,

  token_hidden: false,
  number_hidden: true,

  header_padding: '0',

  logo_image_url: 'theplaza/header-logo-aahope-white.png',
  logo_height: 200,
  logo_hidden: false,
  logo_scale: 1,
  logo_background_color: '#0B132B',

  body_background_color: '#871C4A',

  card_background_color: '#FFFFFF',

  button_color: '#0B132B',
  button_text_color: '#FFFFFF',
  button_hover_color: '#FFFFFF',
  button_outlined_border_color: '#0B132B',
  button_outlined_hover_text_color: '#FFFFFF',
  button_outlined_text_color: '#000000',

  title_weight: 700,
  subtitle_weight: 700,

  text_font: `WorkSans`,
  title_font: `WorkSans`,
  subtitle_font: `WorkSans`,
  legend_color: '#FFFFFF',

  text_color: '#000000',
  title_color: '#000000',
  subtitle_color: '#000000',
  footer_background_color: '#0B132B',
  footer_text_color: '#FFFFFF'
}

export default Theme